import { render, staticRenderFns } from "./recupass.vue?vue&type=template&id=5c6da9f7"
import script from "./recupass.js?vue&type=script&lang=js&external"
export * from "./recupass.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports